'use strict';
'use client';
import { useState as t, useEffect as o } from "react";
import { getUserToken as r } from "../helpers/getUserId.js";
const c = () => {
  const [e, s] = t(!1);
  return o(() => {
    s(!!r());
  }, []), e;
};
export {
  c as useSessionActive
};
